import { useRef } from "react";

export const useOnPress = ({onPress, onUnpress}) => {
    const isPressed = useRef();

    const handlePress = () => {
        if (isPressed.current) return;
        isPressed.current = true;
        onPress();
    }
    const handleUnpress = () => {
        if (!isPressed.current) return;
        isPressed.current = false;
        onUnpress();
    }

    const handleMouseDown = () => {
        handlePress();
        document.addEventListener('mouseup', handleMouseUp);
    }

    const handleMouseUp = () => {
        handleUnpress();
        document.removeEventListener('mouseup', handleMouseUp);
    };

    const handleKeyDown = (e) => {
        if (e.key !== "Enter") return;
        handlePress();
        document.addEventListener("keyup", handleKeyUp);
    }
    const handleKeyUp = (e) => {
        if (e.key !== "Enter") return;
        handleUnpress();
        document.removeEventListener("keyup", removeKeyUp);
    }

    return {onMouseDown: handleMouseDown, onKeyDown: handleKeyDown}
}